import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import { SearchIcon } from './icons';

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  widthClassName?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { label, widthClassName = 'w-64', className, id, ...rest },
  ref,
): JSX.Element {
  const inputId = id ?? `bui-search-${label.replace(/\s+/g, '-').toLowerCase()}`;
  return (
    <div className={clsx('relative flex items-center', widthClassName)}>
      <label htmlFor={inputId} className="bui-sr-only">
        {label}
      </label>
      <SearchIcon
        size={16}
        className="pointer-events-none absolute left-3"
        style={{ color: 'var(--bui-text-placeholder)' }}
      />
      <input
        {...rest}
        ref={ref}
        id={inputId}
        type="search"
        aria-label={label}
        className={clsx(
          'h-9 w-full border bg-white pl-9 pr-3 text-sm outline-none transition-colors',
          'focus-visible:ring-2',
          className,
        )}
        style={{
          borderColor: 'var(--bui-border)',
          color: 'var(--bui-text-primary)',
          borderRadius: 'var(--bui-radius-control, 10px)',
        }}
      />
    </div>
  );
});
